/* DS Wood — reliable scroll reveals (IntersectionObserver + CSS)
   plus GSAP-powered navbar dropdowns. */

(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else { fn(); }
  }

  // Force visibility and full opacity on elements Webflow IX2 would have
  // hidden/faded via inline styles applied by webflow.js. Runs on load and
  // again on an interval to catch late mutations.
  function forceVisible() {
    var selectors = 'h1, h2, [line], .q-a-dropdown, .button-wrapper, .button-wrapper *, [image], .big-yellow-text, .big-yellow-text.plein, .splide__list, .splide__slide';
    document.querySelectorAll(selectors).forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.visibility === 'hidden') {
        el.style.setProperty('visibility', 'visible', 'important');
      }
      // If webflow.js set inline opacity < 1, reset it
      if (el.style.opacity !== '' && parseFloat(el.style.opacity) < 1) {
        el.style.setProperty('opacity', '1', 'important');
      }
    });
  }

  function init() {
    forceVisible();

    var reduced = false;
    try { reduced = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
    if (reduced) return;

    initSectionReveals();

    if (typeof window.gsap !== 'undefined') {
      initNavbarDropdowns(window.gsap);
    }
  }

  // ---------- CSS-based section reveals via IntersectionObserver ----------
  function initSectionReveals() {
    if (!('IntersectionObserver' in window)) return;

    var main = document.querySelector('main.main-wrapper');
    if (!main) return;
    var sections = main.querySelectorAll(':scope > .shopify-section');
    if (!sections.length) return;

    var vh = window.innerHeight || 900;

    // Tag sections for CSS
    sections.forEach(function (s) { s.classList.add('ux-reveal'); });

    // Hero / above-the-fold section: reveal immediately after next frame
    // so the CSS hidden state only lasts one frame (no flash risk)
    if (sections[0]) {
      requestAnimationFrame(function () {
        sections[0].classList.add('is-visible');
      });
    }

    // Observe the rest for scroll reveal
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.05
    });

    for (var i = 1; i < sections.length; i++) {
      // Already in viewport at load? Reveal immediately.
      var rect = sections[i].getBoundingClientRect();
      if (rect.top < vh * 0.95) {
        sections[i].classList.add('is-visible');
      } else {
        observer.observe(sections[i]);
      }
    }

    // Safety net: reveal anything still hidden after 4s (edge case insurance)
    setTimeout(function () {
      sections.forEach(function (s) {
        if (!s.classList.contains('is-visible')) {
          s.classList.add('is-visible');
        }
      });
    }, 4000);
  }

  // ---------- GSAP navbar dropdowns (optional, graceful degrade) ----------
  function initNavbarDropdowns(gsap) {
    if (window.innerWidth < 992) return;

    var dropdowns = document.querySelectorAll('.navbar-dropdown');
    dropdowns.forEach(function (dd) {
      var list = dd.querySelector('.dropdown-list');
      if (!list) return;
      var items = list.querySelectorAll('.link-block, .category-product-item');
      if (!items.length) return;

      dd.addEventListener('mouseenter', function () {
        gsap.fromTo(items,
          { opacity: 0, y: 12 },
          { opacity: 1, y: 0, duration: 0.5, stagger: 0.05, ease: 'power2.out', overwrite: true }
        );
      });
    });
  }

  ready(init);
})();
